import Button from "../../../../../../common/components/atom/Button/Button";
import SelectInput, { OptionList } from "../../../../../../common/components/atom/SelectInput/SelectInput";
import TextInput from "../../../../../../common/components/atom/TextInput/TextInput";
import MessageCard from "../../../../../../common/components/molecule/MessageCard/MessageCard";
import { userGender, UserRole, userRoles, userRolesTraductor } from "../../../../../user/types/user.types";
import {
  CreateUserLinkData,
  ErrorStatus,
} from "../NewCreateUserLinkFormPresenter";
import styles from "./NewCreateUserLinkFormView.module.scss";

export interface NewCreateUserLinkFormViewProps {
  formData?: CreateUserLinkData;
  setFormData: (formData: CreateUserLinkData) => void;
  errorStatus?: ErrorStatus;
  handleSubmit?: () => void;
  messageError?: string | null;
  isLoading?: boolean;
  submitLabel?: string;
  description?: string;
  title?: string;
  maxWidth?: string;
  currentUserRoleCreator: UserRole;
  organizationPickerComponent?: React.ReactNode;
}

/**
 * AddNewCreateUserLinkFormView
 * @returns
 */
export default function AddNewCreateUserLinkFormView({
  handleSubmit,
  messageError,
  errorStatus,
  isLoading,
  submitLabel = "Créer",
  description = "Saisissez les informations du nouvel utilisateur",
  maxWidth = "700px",
  title,
  formData,
  setFormData,
  currentUserRoleCreator,
  organizationPickerComponent,
}: NewCreateUserLinkFormViewProps) {


  const userRoleOptions :  OptionList[]= [];

  const userRoleList = Object.values(userRoles).filter(role => role <= currentUserRoleCreator);

  userRoleList.forEach((role) => {
    userRoleOptions.push({ value: role, label: userRolesTraductor(role) });
  });



  return (
    <div style={{ maxWidth: maxWidth }}>
      <div className={[styles["container"]].join(" ")}>
        {title && (
          <h1 className={[styles["container__title"]].join(" ")}>{title}</h1>
        )}
        <p className={[styles["container__description"]].join(" ")}>
          {description}
        </p>
        <div className={[styles["container__error-message"]].join(" ")}>
          <MessageCard variant="danger" message={messageError} width100 />
        </div>
        <form
          className={[styles["form"]].join(" ")}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit && handleSubmit();
          }}
        >
          <div className={[styles["form__item"]].join(" ")}>
            <SelectInput
              label="Genre de l'utilisateur"
              handleChange={(value) => {
                setFormData({ ...formData, userGender: value });
              }}
              value={formData?.userGender}
              options={[
                { value: userGender.MALE, label: "Homme" },
                { value: userGender.FEMALE, label: "Femme" },
                { value: userGender.OTHER, label: "Autre" },
              ]}
              error={errorStatus?.isGenderError}
            />
          </div>
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Prénom de l'utilisateur"
              value={formData?.firstnameUser}
              error={errorStatus?.isErrorFirstnameUser}
              onChange={(e) => {
                setFormData({ ...formData, firstnameUser: e.target.value });
              }}
            />
          </div>
 
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Nom  de l'utilisateur"
              value={formData?.lastnameUser}
              error={errorStatus?.isErrorlLastnameUser}
              onChange={(e) => {
                setFormData({ ...formData, lastnameUser: e.target.value });
              }}
            />
          </div>
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Email de l'utilisateur"
              value={formData?.emailUser}
              error={errorStatus?.isErrorEmailUser}
              onChange={(e) => {
                setFormData({ ...formData, emailUser: e.target.value });
              }}
            />
          </div>
          <div className={[styles["form__item"]].join(" ")}>
            <SelectInput
              label="Rôle"
              handleChange={(value) => {
                setFormData({ ...formData, userRole: value });
              }}
              value={formData?.userRole}
              error={errorStatus?.isErrorUserRole}
              options={userRoleOptions || []}
            />
          </div>

          {
            organizationPickerComponent && (currentUserRoleCreator >= userRoles.SUPER_ADMIN) && (
              <div className={[styles["form__item"]].join(" ")}>
                {organizationPickerComponent}
              </div>
            )
          }

          <div className={[styles["form__button-container"]].join(" ")}>
            <div className={[styles["form__button-container__item"]].join(" ")}>
              <Button
                isLoading={isLoading}
                onClick={handleSubmit}
                type={"submit"}
              >
                {submitLabel}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
